import classNames from "classnames";
import { Button } from "../../../general-ui/button/button";
import Icon, { COLORS, ICONS } from "../../../general-ui/icon";


interface FiresideFullscreenButtonProps {
	isFullScreen: boolean;
	goFullScreenCB: (e?: any) => void;
	isAdmin?: boolean;
}

export default function FiresideFullscreenButton({ isFullScreen, goFullScreenCB, isAdmin = false }: FiresideFullscreenButtonProps): JSX.Element {
	return (
		<Button
			onClick={goFullScreenCB}
			classButton={classNames('player-button', 'full-screen-button')}
			animate={true}
			isDisabled={isAdmin}
		>
			<Icon name={isFullScreen ? ICONS.MINIMIZE_SCREEN : ICONS.FULLSCREEN} size={18} color={COLORS.WHITE} />
		</Button>
	);
}